import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import { GOOGLE_API_TOKEN } from '../../common/constants';
import { Icon } from 'semantic-ui-react';


// const AnyReactComponent = ({ text }) => <div>{text}</div>;
const hostelLat = 37.179188;
const hostelLng = -3.596174;

const Marker = (props) => {

  return (
    <div className='marker'>
      <Icon size='big' color='red' name="map marker alternate" />
      <span><b>{props.name}</b></span>
    </div>
  );
};

export default class HostelLocation extends Component {
  static propTypes = {

  };
  static defaultProps = {
    center: {
      lat: hostelLat,
      lng: hostelLng
    },
    zoom: 17
  };
  render() {
    return (
      <div className="common-hostel-location">
        <GoogleMapReact
          bootstrapURLKeys={{
            key: GOOGLE_API_TOKEN,
          }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <Marker
            lat={hostelLat}
            lng={hostelLng}
            name="Oripando Hostel"
          />
        </GoogleMapReact>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/HostelLocation.js